import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import QandA from "./QandA";

const QuestionList = ({questions}) => {
 
    return (
    <Container fluid>
      {questions.map((question, index) => (
        <Row className="justify-content-center" key={"row" + index} style={{ paddingTop: "10px" }}>
          <Col lg="8">
            <QandA
              eventKey={index}
              isAdmin={false}
              key={"question" + index}
              onVoteClick={null}
              question={question}
            />
          </Col>
        </Row>
      ))}
    </Container>
  );
}

export default QuestionList;

